import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { E_FLOW_HEX, L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
export const DETANDER_CONFIG = {
    type: ERFElement.Detander,
    icon: 'Detander_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_flow',
                    type: 'target',
                    name: 'Входной материальный поток',
                    position: Position.Top,
                    style: { top: 21, left: 38, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_flow',
                    type: 'source',
                    name: 'Выходной материальный поток',
                    position: Position.Top,
                    style: { top: 15, left: 50, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_energy_flow',
                    type: 'source',
                    name: 'Выходной энергетический поток',
                    position: Position.Left,
                    style: { top: 25, left: 7, background: E_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 38, left: 7, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 54, right: 10, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFDetanderNode.config.js.map